import bs58 from 'bs58'

import { Address, Formatted } from '~/utils/address/types'

export type Type = Address<string, 'solana'>

export function validate(str: string): str is Type {
  try {
    const decoded = bs58.decode(str)
    if (decoded.length === 32) {
      return true
    }
  } catch {
    return false
  }

  return false
}

export function format(str: string): Formatted<Type> {
  if (validate(str)) {
    return str as Formatted<Type>
  }

  throw new Error(`Invalid solana address: ${str}`)
}
